//import logo from "./logo.svg";
import "./App.css";
import React, { useState ,useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useLocation } from 'react-router-dom';
import {BrowserRouter as Router,Route,Routes,// Navigate,Link,
} from "react-router-dom";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import StickyFooter from "./Components/CommonUI/StickyFooter/StickyFooter";
import Home from "./Components/Home/Home";  
import KeevInner from "./Components/WelcomeNewInner/KeevInner/KeevInner";  
import MarginInner from "./Components/WelcomeNewInner/MarginInner/MarginInner"; 
import ProdcutPage from "./Components/WelcomeNewInner/ProdcutPage/ProdcutPage"; 
import TradingView from "./Components/WelcomeNewInner/TradingView/TradingView"; 
import InvesterRelation from "./Components/InvesterRelation/InvesterRelation";  
import About from "./Components/About/About";
import Products from "./Components/Products/Products";
import Pricing from "./Components/Pricing/Pricing";
import NotFound from "./Components/NotFound/NotFound";
import ProductEquity from "./Components/ProductEquity/ProductEquity";
import AllEquities from "./Components/AllEquities/AllEquities";
import AllMutualFund from "./Components/AllMutualFund/AllMutualFund";
import ProductMutualFund from "./Components/ProductMutualFund/ProductMutualFund";
import CompanySnapshot from "./Components/CompanySnapshot/CompanySnapshot";
import SchemeSnapshot from "./Components/SchemeSnapshot/SchemeSnapshot";
import CommonProvider from "./provider/CommonProvider";
import FoxTrader from "./Components/FoxTrader/FoxTrader";
import TradeTron from "./Components/TradeTron/TradeTron";
import IPOProduct from "./Components/AllProducts/IPOProduct/IPOProduct";
import ETFProduct from "./Components/AllProducts/ETFProduct/ETFProduct";
import CurrencyProduct from "./Components/AllProducts/CurrencyProduct/CurrencyProduct";
import MFProduct from "./Components/AllProducts/MFProduct/MFProduct";
import CommoditiesProduct from "./Components/AllProducts/CommoditiesProduct/CommoditiesProduct";
import FnOProduct from "./Components/AllProducts/FnOProduct/FnOProduct";
import Disclaimer from "./Components/FooterLinkData/Disclaimer/Disclaimer";
import PrivacyPolicy from "./Components/FooterLinkData/PrivacyPolicy/PrivacyPolicy";
import TermsCondition from "./Components/FooterLinkData/TermsCondition/TermsCondition";
import InvestorCharter from "./Components/FooterLinkData/InvestorCharter/InvestorCharter";
import MarketTalks from "./Components/MarketTalks/MarketTalks";
import Market from "./Components/Market/Market";
import MarketEquity from "./Components/MarketEquity/MarketEquity";
import GainersAndLosers from "./Components/MarketEquity/GainersAndLosers/GainersAndLosers";
import ExchangeHolidays from "./Components/MarketEquity/ExchangeHolidays/ExchangeHolidays";
import HistoricalReturn from "./Components/MarketEquity/HistoricalReturn/HistoricalReturn";
import BetaStockwise from "./Components/MarketEquity/BetaStockwise/BetaStockwise";
import DeliverableVolume from "./Components/MarketEquity/DeliverableVolume/DeliverableVolume";
import OnlyBuyerSellers from "./Components/MarketEquity/OnlyBuyerSellers/OnlyBuyerSellers";
import AdvancesDeclines from "./Components/MarketEquity/AdvancesDeclines/AdvancesDeclines";
import BlockDeals from "./Components/MarketEquity/BlockDeals/BlockDeals";
import BulkDeals from "./Components/MarketEquity/BulkDeals/BulkDeals";
import ChartIntradaySensex from "./Components/MarketEquity/ChartIntradaySensex/ChartIntradaySensex";
import FiftyTwoWeekHighLow from "./Components/MarketEquity/FiftyTwoWeekHighLow/FiftyTwoWeekHighLow";
import FiveDayUpandDown from "./Components/MarketEquity/FiveDayUpandDown/FiveDayUpandDown";
import IndexConstituents from "./Components/MarketEquity/IndexConstituents/IndexConstituents";
import LiveIndices from "./Components/MarketEquity/LiveIndices/LiveIndices";
import NewHighsAndLows from "./Components/MarketEquity/NewHighsAndLows/NewHighsAndLows";
import OutAndUnderPerformers from "./Components/MarketEquity/OutAndUnderPerformers/OutAndUnderPerformers";
import RisingFalling from "./Components/MarketEquity/RisingFalling/RisingFalling";
import RisingVDP from "./Components/MarketEquity/RisingVDP/RisingVDP";
import UnusualVolume from "./Components/MarketEquity/UnusualVolume/UnusualVolume";
import ValueVolumeToppers from "./Components/MarketEquity/ValueVolumeToppers/ValueVolumeToppers";
import GetQuotes from "./Components/MarketEquity/CompanyProfile/GetQuotes/GetQuotes";
import Prvquartercomp from "./Components/MarketEquity/CompanyProfile/Prvquartercomp/Prvquartercomp";
import CompanyBackground from "./Components/MarketEquity/CompanyProfile/CompanyBackground/CompanyBackground";
import BalanceSheet from "./Components/MarketEquity/CompanyProfile/BalanceSheet/BalanceSheet";
import BoardMeetings from "./Components/MarketEquity/CompanyProfile/BoardMeetings/BoardMeetings";
import BoardOfDirector from "./Components/MarketEquity/CompanyProfile/BoardOfDirector/BoardOfDirector";
import Bonus from "./Components/MarketEquity/CompanyProfile/Bonus/Bonus";
import IntradayCharts from "./Components/MarketEquity/CompanyProfile/IntradayCharts/IntradayCharts";
import BookClosure from "./Components/MarketEquity/CompanyProfile/BookClosure/BookClosure";
import CashFlow from "./Components/MarketEquity/CompanyProfile/CashFlow/CashFlow";
import CompanyNews from "./Components/MarketEquity/CompanyProfile/CompanyNews/CompanyNews";
import DirectoresReports from "./Components/MarketEquity/CompanyProfile/DirectoresReports/DirectoresReports";
import Dividend from "./Components/MarketEquity/CompanyProfile/Dividend/Dividend";
import KeyFinancialRatios from "./Components/MarketEquity/CompanyProfile/KeyFinancialRatios/KeyFinancialRatios";
import MarketAnnouncement from "./Components/MarketEquity/CompanyProfile/MarketAnnouncement/MarketAnnouncement";
import MarketShareHolding from "./Components/MarketEquity/CompanyProfile/MarketShareHolding/MarketShareHolding";
import MFHoldings from "./Components/MarketEquity/CompanyProfile/MFHoldings/MFHoldings";
import NameChangeComp from "./Components/MarketEquity/CompanyProfile/NameChangeComp/NameChangeComp";
import ProfitAndLoss from "./Components/MarketEquity/CompanyProfile/ProfitAndLoss/ProfitAndLoss";
import QuarterlyResults from "./Components/MarketEquity/CompanyProfile/QuarterlyResults/QuarterlyResults";
import Right from "./Components/MarketEquity/CompanyProfile/Right/Right";
import SharePrice from "./Components/MarketEquity/CompanyProfile/SharePrice/SharePrice";
import PeerComparisonMarket from "./Components/MarketEquity/CompanyProfile/PeerComparisonMarket/PeerComparisonMarket";
import ReferEarn from "./Components/ReferEarn/ReferEarn";
import ReferEarnNew from "./Components/ReferEarn/ReferEarnNew/ReferEarnNew";
import ReferSignUp from "./Components/ReferEarn/ReferEarnNew/ReferSignUp"
import CorporateNews from "./Components/MarketEquity/CompanyNews/CorporateNews/CorporateNews";
import EconomyNews from "./Components/MarketEquity/CompanyNews/EconomyNews/EconomyNews";
import Corporateresults from "./Components/MarketEquity/CompanyNews/Corporateresults/Corporateresults";
import EndSessionCommentary from "./Components/MarketEquity/CompanyNews/EndSessionCommentary/EndSessionCommentary";
import ForeignMarkets from "./Components/MarketEquity/CompanyNews/ForeignMarkets/ForeignMarkets";
import HotPursuit from "./Components/MarketEquity/CompanyNews/HotPursuit/HotPursuit";
import NewsDetails from "./Components/MarketEquity/CompanyNews/NewsDetails/NewsDetails";
import MarketBeat from "./Components/MarketEquity/CompanyNews/MarketBeat/MarketBeat";
import Midsession from "./Components/MarketEquity/CompanyNews/Midsession/Midsession";
import OtherMarkets from "./Components/MarketEquity/CompanyNews/OtherMarkets/OtherMarkets";
import Presession from "./Components/MarketEquity/CompanyNews/Presession/Presession";
import Stockalert from "./Components/MarketEquity/CompanyNews/Stockalert/Stockalert";
import Futuresmarket from "./Components/MarketEquity/CompanyNews/Futuresmarket/Futuresmarket";
import ADRPrice from "./Components/MarketEquity/OtherMarketInfo/ADRPrice/ADRPrice";
import Forexdetails from "./Components/MarketEquity/OtherMarketInfo/Forexdetails/Forexdetails";
import FIIInvestment from "./Components/MarketEquity/OtherMarketInfo/FIIInvestment/FIIInvestment";
import MFIInvestment from "./Components/MarketEquity/OtherMarketInfo/MFIInvestment/MFIInvestment";
import WorldIndices from "./Components/MarketEquity/OtherMarketInfo/WorldIndices/WorldIndices";
import Announcement from "./Components/MarketEquity/CorporateAction/Announcement/Announcement";
import Boardmeeting from "./Components/MarketEquity/CorporateAction/Boardmeeting/Boardmeeting";
import Bookclosur from "./Components/MarketEquity/CorporateAction/Bookclosur/Bookclosur";
import Buybacklist from "./Components/MarketEquity/CorporateAction/Buybacklist/Buybacklist";
import FaceValue from "./Components/MarketEquity/CorporateAction/FaceValue/FaceValue";
import MarketTurnOver from "./Components/MarketEquity/CorporateAction/MarketTurnOver/MarketTurnOver";
import NamechangeA from "./Components/MarketEquity/CorporateAction/NamechangeA/NamechangeA";
import Rightsissues from "./Components/MarketEquity/CorporateAction/Rightsissues/Rightsissues";
import Dividendcopaction from "./Components/MarketEquity/CorporateAction/Dividendcopaction/Dividendcopaction";
import Bonusissues from "./Components/MarketEquity/CorporateAction/Bonusissues/Bonusissues";
import Delistedshares from "./Components/MarketEquity/CorporateAction/Delistedshares/Delistedshares";
import DailyNav from "./Components/MutualFund/DailyNav/DailyNav";
import HistoricalNav from "./Components/MutualFund/HistoricalNav/HistoricalNav";
import MFActivities from "./Components/MutualFund/MFActivities/MFActivities";
import TopHolding from "./Components/MutualFund/TopHolding/TopHolding";
import Categoryreturn from "./Components/MutualFund/Categoryreturn/Categoryreturn";
import FundProfile from "./Components/MutualFund/FundProfile/FundProfile";
import WhatsInOut from "./Components/MutualFund/WhatsInOut/WhatsInOut";
import Mutualnews from "./Components/MutualFund/Mutualnews/Mutualnews";
import Newfundoffer from "./Components/MutualFund/Newfundoffer/Newfundoffer";
import Leastvolatile from "./Components/MutualFund/Leastvolatile/Leastvolatile";
import MFSynopsis from "./Components/MutualFund/MFSynopsis/MFSynopsis";
import Dividenddetails from "./Components/MutualFund/Dividenddetails/Dividenddetails";
import Schemecomparison from "./Components/MutualFund/Schemecomparison/Schemecomparison";
import Fundperformans from "./Components/MutualFund/Fundperformans/Fundperformans";
import BasisOfAllotment from "./Components/IPO/BasisOfAllotment/BasisOfAllotment";
import BestPerformers from "./Components/IPO/BestPerformers/BestPerformers";
import Closedipos from "./Components/IPO/Closedipos/Closedipos";
import DraftProsp from "./Components/IPO/DraftProsp/DraftProsp";
import Forthcoming from "./Components/IPO/Forthcoming/Forthcoming";
import Newlisting from "./Components/IPO/Newlisting/Newlisting";
import ReferralProgramPolicy from "./Components/ReferEarn/ReferEarnNew/ReferralProgramPolicy";
import Openipos from "./Components/IPO/Openipos/Openipos";
import IPOSynopsis from "./Components/IPO/IPOSynopsis/IPOSynopsis";
import IPONews from "./Components/IPO/IPONews/IPONews"; //src/Components/ReferEarn/ReferEarnNew/ReferSignUp.js
import NiftyFutures from "./Components/MarketFandO/DerivativeUpdates/NiftyFutures/NiftyFutures";
import TopValueTraded from "./Components/MarketFandO/DerivativeUpdates/TopValueTraded/TopValueTraded";
import CostOfCarry from "./Components/MarketFandO/DerivativeUpdates/CostOfCarry/CostOfCarry";
import DerivativeNews from "./Components/MarketFandO/DerivativeUpdates/DerivativeNews/DerivativeNews";
import DerivativeSummary from "./Components/MarketFandO/DerivativeUpdates/DerivativeSummary/DerivativeSummary";
import FIIStatistics from "./Components/MarketFandO/DerivativeUpdates/FIIStatistics/FIIStatistics";
import ListOfUnderlyings from "./Components/MarketFandO/DerivativeUpdates/ListOfUnderlyings/ListOfUnderlyings";
import PositionLimit from "./Components/MarketFandO/DerivativeUpdates/PositionLimit/PositionLimit";
import PutCallRatio from "./Components/MarketFandO/DerivativeUpdates/PutCallRatio/PutCallRatio";
import RollOver from "./Components/MarketFandO/DerivativeUpdates/RollOver/RollOver";
import TopQuantity from "./Components/MarketFandO/DerivativeUpdates/TopQuantity/TopQuantity";
import AllIndexFuture from "./Components/MarketFandO/FNOfutures/AllIndexFuture/AllIndexFuture";
import DecreaseInOI from "./Components/MarketFandO/FNOfutures/DecreaseInOI/DecreaseInOI";
import HighestInOI from "./Components/MarketFandO/FNOfutures/HighestInOI/HighestInOI";
import IncreaseInOI from "./Components/MarketFandO/FNOfutures/IncreaseInOI/IncreaseInOI";
import LowestInOI from "./Components/MarketFandO/FNOfutures/LowestInOI/LowestInOI";
import MostActiveContracts from "./Components/MarketFandO/FNOfutures/MostActiveContracts/MostActiveContracts";
import TLosers from "./Components/MarketFandO/FNOfutures/TLosers/TLosers";
import Topgain from "./Components/MarketFandO/FNOfutures/Topgain/Topgain";
import DecreaseOI from "./Components/MarketFandO/FNOoptions/DecreaseOI/DecreaseOI";
import HighOI from "./Components/MarketFandO/FNOoptions/HighOI/HighOI";
import IncreaseOI from "./Components/MarketFandO/FNOoptions/IncreaseOI/IncreaseOI";
import LowOI from "./Components/MarketFandO/FNOoptions/LowOI/LowOI";
import OptionChains from "./Components/MarketFandO/FNOoptions/OptionChains/OptionChains";
import MostActiveCallOPT from "./Components/MarketFandO/FNOoptions/MostActiveCallOPT";
import MostActivePutOPT from "./Components/MarketFandO/FNOoptions/MostActivePutOPT";
import TopGainers from "./Components/MarketFandO/FNOoptions/TopGainers/TopGainers";
import TopLosers from "./Components/MarketFandO/FNOoptions/TopLosers/TopLosers";
import LoginPopup from "./Components/CommonUI/LoginPopup/LoginPopup";
import OurTools from "./Components/OurTools/OurTools";
import AlgoTrading from "./Components/OurTools/AlgoTrading/AlgoTrading/AlgoTrading";
//import BrokerageAndCalculators from "./Components/BrokerageAndCalculators/BrokerageAndCalculators";
// import EMICalculator from "./Components/Calculators/EMICalculator/EMICalculator";
// import Brokaragecalculator from "./Components/BrokerageAndCalculators/Brokaragecalculator";
import Contact from "./Components/Contact/Contact";
import DialNTrade from "./Components/DialNTrade/DialNTrade";
import Downloads from "./Components/Downloads/downloads";
import PartnerUsNew from "./Components/PartnerUsNew/PartnerUsNew";
import Sitemap from "./Components/Sitemap/Sitemap";
import Research from "./Components/Research/Research";
import ResearchReport from "./Components/ResearchReport/ResearchReport";
import AlgoBulls from "./Components/AlgoBulls/AlgoBulls";
import Morningnote from "./Components/Research/Morningnote/Morningnote";
import Markethunt from "./Components/Research/Markethunt/Markethunt";
//import Algotradinglanding from "./Components/landing/Algotradinglanding/Algotradinglanding";
import CareerInner from "./Components/CareerInner/CareerInner";
import CareerLanding from "./Components/CareerLanding/CareerLanding";
import Career from "./Components/Career/Career";
import AlgoTradingad2 from "./Components/landing/AlgoTrading-ad/AlgoTrading-ad2/AlgoTrading-ad2";
import DematAccountad1 from "./Components/landing/DematAccount-ad/DematAccount-ad1/DematAccount-ad1";
import ThankYouPage from "./Components/landing/ThankYou/ThankYou";
import AccountClosure from "./Components/AccountClosure/AccountClosure";
import AccountClosureOption from "./Components/AccountClosure/AccountClosureOption/AccountClosureOption";
import AccountClosureForm from "./Components/AccountClosure/AccountClosureForm/AccountClosureForm";
import { HelmetProvider } from 'react-helmet-async';
// import Fdcalculator from './Components/BrokerageAndCalculators/Fdcalculator';
// import Emicalculator from './Components/BrokerageAndCalculators/Emicalculator';
// import Elsscalculator from './Components/BrokerageAndCalculators/Elsscalculator';
import Brokaragecalculator from "./Components/BrokerageAndCalculators/Brokaragecalculator";
import Fdcalculator from './Components/BrokerageAndCalculators/Fdcalculator';
import Emicalculator from './Components/BrokerageAndCalculators/Emicalculator';
import Elsscalculator from './Components/BrokerageAndCalculators/Elsscalculator';
import SIPCalculator from "./Components/MutualFund/SIPCalculator/SIPCalculator";
import NomineeUpdation from "./Components/nominee-updation-2023/Nominee-updation-2023";
import RiskDisclosures from "./Components/RiskDisclosures/RiskDisclosures";
import Quantman from "./Components/Quantman/Quantman";
import CompanySnapshotIframe from "./Components/CompanySnapshotIframe/CompanySnapshotIframe";
import AlgoTest from "./Components/AlgoTest/AlgoTest";
import SmartOptions from "./Components/SmartOptions/SmartOptions";
import FraudAlert from "./Components/FraudAlert/FraudAlert";
import TradeRadarAlgoFb from "./Components/TradeRadarAlgoFb/TradeRadarAlgoFb"
import TradeRadarAlgoFbBlack from "./Components/TradeRadarAlgoFb/TradeRadarAlgoFbOptionBlack"

// const pathArr = ["/AlgoTrading-ad1", "/FutureOption-ad1", "/AlgoTrading-ad2", "/DematAccount-ad1"]
const pathArr = ["/AlgoTrading-ad2", "/DematAccount-ad1"]

const pathArrStock = ["CompanySnapshot"]
// const pathscript = ["/AlgoTrading-ad1","/FutureOption-ad1","/DematAccount-ad1"]

const report = ['/Research/margin-report']
function External() {
    window.location.href = 'http://www.mansukh.net/Static/backoffice.aspx';
    return null;
}
function Externalmyaccount() {
    window.location.href = 'http://www.mansukh.net/Static/my-account.aspx';
    return null;
}
function Externalonlinetrading() {
    window.location.href = 'http://www.mansukh.net/static/online-share-trading.aspx';
    return null;
}
function ExternalCareer() {
    window.location.href = 'http://www.mansukh.net/Static/careers.aspx';
    return null;
}
function Externalresearch() {
    window.location.href = '/Research';
    return null;
}
function Externalhome() {
    window.location.href = '/';
    return null;
}

function ExternalTermsandcondition() {
    window.location.href = '/TermsCondition';
    return null;
}
function ExternalContact() {
    window.location.href = '/Contact';
    return null;
}
function ExternalCareerLanding() {
    window.location.href = '/Careers';
    return null;
}
function MarketFeedRedirect() {
  useEffect(() => {
    // redirect to the HTML page in public folder
    window.location.href = "/api.html";
  }, []);

  return null;
}


function App() {
    const location = useLocation();
    var internalResearch = '', internalhome = '';
    //console.log(location.pathname);
    if (location.pathname.includes("/Research")) {
        if (location.pathname.includes(".aspx")) {
            internalResearch = location.pathname;
            // console.log("internalResearch:" + internalResearch);
        }
    }
    if (location.pathname.includes("/home")) {
        if (location.pathname.includes(".aspx")) {
            internalhome = location.pathname;
        }
    }

      // Paths where you want to hide Header/Footer/StickyFooter
  const noHeaderFooterPaths = [
    "/Trade-Radar-Algo-G",
    "/TradeRadar-Algo-Fb"
  ];

  const currentPath = window.location.pathname;
    // if (window.location.pathname.toLocaleLowerCase().indexOf("/algotrading-ad1") >= 0)
    // {
    //     alert("hiii"); 
    //     const script = document.createElement("script");
    //     script.src = '//in.fw-cdn.com/30289592/167137.js';
    //     script.async = true;
    //     script.chat = 'false';
    //     document.body.appendChild(script);
    // }
if(location.pathname.includes('/TradeTron') || location.pathname.includes('/AlgoBulls') || location.pathname.includes('/Quantman') ||location.pathname.includes('/keev')){
    window.location.href = '/AlgoTrading';
}

    return (
        <>

            <div className="App">
                <CommonProvider>
                    <HelmetProvider>
                        {/* {pathscript.includes(window.location.pathname) && <ScriptCommon />} */}
                        {/* {!pathArr.includes(window.location.pathname) && <Header />} */}
                        {/* {(window.location.pathname.split('/')[1] != 'CompanySnapshot') ? !pathArr.includes(window.location.pathname) && <Header /> :
                            !pathArrStock.includes(window.location.pathname.split('/')[1]) && <Header />} */}
                         {(window.location.pathname.split('/')[1] !== 'CompanySnapshot') ? (!pathArr.includes(currentPath) &&!noHeaderFooterPaths.includes(currentPath) && <Header />) : (!pathArrStock.includes(window.location.pathname.split('/')[1]) &&!noHeaderFooterPaths.includes(currentPath) && <Header />)}      
                             {window.location.pathname === '/' && <FraudAlert />} 
                        <Routes>

                            <Route path="/" element={<Home />} exact />
                            <Route path="/about" element={<About />} />
                            <Route path="/products" element={<Products />} />
                            <Route path="/pricing" element={<Pricing />} />
                            <Route path="/Equity" element={<ProductEquity />} />
                            <Route path="/allEquities" element={<AllEquities />} />
                            <Route path="/allMutualFund" element={<AllMutualFund />} />
                            {/* <Route path="/Futures-and-Options" element={<Market />} /> */}
                            <Route path="/Mutual-Fund" element={<ProductMutualFund />} />
                            <Route path="/companySnapshot/:exchg/:cocode" element={<CompanySnapshot />} />
                            <Route path="/Mutual-Fund/:MFCode" element={<SchemeSnapshot />} />
                            <Route path="*" element={<NotFound />} />
                            <Route path="/FoxTrader" element={<FoxTrader />} />
                            {/* <Route path="/Event-Tracker" element={<Market />} /> */}
                            <Route path="/TradeTron" element={<TradeTron />} />
                            {/* <Route path="/TradeRadar" element={<TradeRadar />} /> */}
                            <Route path="/TradeRadar" element={<AlgoTest />} />
                            <Route path="/Trade-Radar" element={<AlgoTest />} />
                            <Route path="/SmartOptions" element={<SmartOptions />} />
                            <Route path="*" element={<NotFound />} />
                            <Route path="/IPO" element={<IPOProduct />} />
                            {/* <Route path="/Stocks" element={<Market />} /> */}
                            <Route path="/ETF" element={<ETFProduct />} />
                            <Route path="/Currency" element={<CurrencyProduct />} />
                            <Route path="/MFP" element={<MFProduct />} />
                            <Route path="/Commodities" element={<CommoditiesProduct />} />
                            <Route path="/FnO" element={<FnOProduct />} />
                            <Route path="/Disclaimer" element={<Disclaimer />} />
                            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
                            {/* <Route path="/SGB" element={<Market />} /> */}
                            <Route path="/TermsCondition" element={<TermsCondition />} />
                            <Route path="/InvestorCharter" element={<InvestorCharter />} />
                            <Route path="/MarketTalks" element={<MarketTalks />} />
                            <Route path="/market/:tabName" element={<Market />} />
                            <Route path="/MarketEquity" element={<MarketEquity />} />
                            <Route path="/MarketEquity/Gainers-And-Losers" element={<GainersAndLosers />} />
                            <Route path="/MarketEquity/Exchange-Holidays" element={<ExchangeHolidays />} />
                            <Route path="/MarketEquity/Historical-Returns" element={<HistoricalReturn />} />
                            <Route path="/MarketEquity/Only-Buyers-Sellers" element={<OnlyBuyerSellers />} />
                            <Route path="/MarketEquity/Beta-Stock-wise" element={<BetaStockwise />} />
                            <Route path="/MarketEquity/Deliverable-Volumes" element={<DeliverableVolume />} />
                            <Route path="/MarketEquity/Block-Deals" element={<BlockDeals />} />
                            <Route path="/MarketEquity/Bulk-Deals" element={<BulkDeals />} />
                            <Route path="/MarketEquity/Live-Indices" element={<LiveIndices />} />
                            <Route path="/MarketEquity/Out-Under-Performers" element={<OutAndUnderPerformers />} />
                            <Route path="/MarketEquity/Unusual-Volume" element={<UnusualVolume />} />
                            <Route path="/MarketEquity/Value-Volume-Toppers" element={<ValueVolumeToppers />} />
                            <Route path="/MarketEquity/52-Week-High-Low" element={<FiftyTwoWeekHighLow />} />
                            <Route path="/MarketEquity/Advance-and-Decline" element={<AdvancesDeclines />} />
                            <Route path="/MarketEquity/New-High-Low" element={<NewHighsAndLows />} />
                            <Route path="/MarketEquity/Index-Constituents" element={<IndexConstituents />} />
                            <Route path="/MarketEquity/Rising-VDP" element={<RisingVDP />} />
                            <Route path="/MarketEquity/Rising-Volume-Delivery-Fall-In-Price" element={<RisingFalling />} />
                            <Route path="/MarketEquity/Chart-Intraday-Sensex" element={<ChartIntradaySensex />} />
                            <Route path="/MarketEquity/5-Days-Up-Down" element={<FiveDayUpandDown />} />
                            <Route path="/CompanyProfile/Get-Quotes" element={<GetQuotes />} />
                            <Route path="/CompanyProfile/Company-Background/:getCompName" element={<CompanyBackground />} />
                            <Route path="/CompanyProfile/Balance-Sheet/:getCompName" element={<BalanceSheet />} />
                            <Route path="/CompanyProfile/Board-of-Directors/:getCompName" element={<BoardOfDirector />} />
                            <Route path="/CompanyProfile/Profit-Loss-Accounts/:getCompName" element={<ProfitAndLoss />} />
                            <Route path="/CompanyProfile/Prev-Quarter-Comp/:getCompName" element={<Prvquartercomp />} />
                            <Route path="/CompanyProfile/Quarterly-Results/:getCompName" element={<QuarterlyResults />} />
                            <Route path="/CompanyProfile/Key-Financial-Ratios/:getCompName" element={<KeyFinancialRatios />} />
                            <Route path="/CompanyProfile/Share-Price/:getCompName" element={<SharePrice />} />
                            <Route path="/CompanyProfile/Share-Holding-Pattern/:getCompName" element={<MarketShareHolding />} />
                            <Route path="/CompanyProfile/Intraday-charts/:getCompName" element={<IntradayCharts />} />
                            <Route path="/CompanyProfile/Cash-Flow/:getCompName" element={<CashFlow />} />
                            <Route path="/CompanyProfile/Directors-Reports/:getCompName" element={<DirectoresReports />} />
                            <Route path="/CompanyProfile/MF-Holdings/:getCompName" element={<MFHoldings />} />
                            <Route path="/CompanyProfile/Name-Change/:getCompName" element={<NameChangeComp />} />
                            <Route path="/CompanyProfile/Company-News/:getCompName" element={<CompanyNews />} />
                            <Route path="/CompanyProfile/Peer-Comparison/:getCompName" element={<PeerComparisonMarket />} />
                            <Route path="/CompanyProfile/Bonus-History/:getCompName" element={<Bonus />} />
                            <Route path="/CompanyProfile/Dividend/:getCompName" element={<Dividend />} />
                            <Route path="/CompanyProfile/Rights/:getCompName" element={<Right />} />
                            <Route path="/CompanyProfile/Announcements/:getCompName" element={<MarketAnnouncement />} />
                            <Route path="/CompanyProfile/Board-Meeting/:getCompName" element={<BoardMeetings />} />
                            <Route path="/CompanyProfile/Book-Closure/:getCompName" element={<BookClosure />} />
                            <Route path="/CompanyNews/Corporate-News" element={<CorporateNews />} />
                            <Route path="/CompanyNews/Economy-News" element={<EconomyNews />} />
                            <Route path="/CompanyNews/End-Session-Commentary" element={<EndSessionCommentary />} />
                            <Route path="/CompanyNews/Foreign-Markets" element={<ForeignMarkets />} />
                            <Route path="/CompanyNews/Hot-Pursuit" element={<HotPursuit />} />
                            <Route path="/CompanyNews/Market-Beat" element={<MarketBeat />} />
                            <Route path="/CompanyNews/Mid-Session-Commentary" element={<Midsession />} />
                            <Route path="/CompanyNews/Other-Markets-News" element={<OtherMarkets />} />
                            <Route path="/CompanyNews/Pre-Session-Commentary" element={<Presession />} />
                            <Route path="/CompanyNews/Corporate-Results" element={<Corporateresults />} />
                            <Route path="/CompanyNews/Stock-Alert" element={<Stockalert />} />
                            <Route path="/CompanyNews/Futures-Market" element={<Futuresmarket />} />
                            <Route path="/Detail-News/:fetchId/:fetchHead" element={<NewsDetails />} />
                            <Route path="/CorporateAction/Daily-Announcements" element={<Announcement />} />
                            <Route path="/CorporateAction/Board-Meetings" element={<Boardmeeting />} />
                            <Route path="/CorporateAction/Book-Closure" element={<Bookclosur />} />
                            <Route path="/CorporateAction/Bonus" element={<Bonusissues />} />
                            <Route path="/CorporateAction/Rights" element={<Rightsissues />} />
                            <Route path="/CorporateAction/BuyBack-List" element={<Buybacklist />} />
                            <Route path="/CorporateAction/Dividend" element={<Dividendcopaction />} />
                            <Route path="/CorporateAction/De-listed-Shares" element={<Delistedshares />} />
                            <Route path="/CorporateAction/Market-Turnover" element={<MarketTurnOver />} />
                            <Route path="/CorporateAction/Change-Name" element={<NamechangeA />} />
                            <Route path="/CorporateAction/Split-Face-Value" element={<FaceValue />} />
                            <Route path="/OtherMarket/FII-Investment" element={<FIIInvestment />} />
                            <Route path="/OtherMarket/MF-Investment" element={<MFIInvestment />} />
                            <Route path="/OtherMarket/World-Indices" element={<WorldIndices />} />
                            <Route path="/OtherMarket/ADR-Prices" element={<ADRPrice />} />
                            <Route path="/OtherMarket/Forex" element={<Forexdetails />} />
                            <Route path="/MutualFund/Daily-NAV" element={<DailyNav />} />
                            <Route path="/MutualFund/New-Fund-Offer" element={<Newfundoffer />} />
                            <Route path="/MutualFund/What's-In-and-Out" element={<WhatsInOut />} />
                            <Route path="/MutualFund/MF-Synopsis" element={<MFSynopsis />} />
                            <Route path="/MutualFund/Least-Volatile-Schemes" element={<Leastvolatile />} />
                            <Route path="/MutualFund/Dividend-Details" element={<Dividenddetails />} />
                            <Route path="/MutualFund/Scheme-Comparison" element={<Schemecomparison />} />
                            <Route path="/MutualFund/Fund-Performance" element={<Fundperformans />} />
                            <Route path="/IPO/Forthcoming-IPO" element={<Forthcoming />} />
                            <Route path="/IPO/Open-IPO" element={<Openipos />} />
                            <Route path="/IPO/Closed-IPO" element={<Closedipos />} />
                            <Route path="/IPO/New-Listing" element={<Newlisting />} />
                            <Route path="/IPO/Basis-Of-Allotment" element={<BasisOfAllotment />} />
                            <Route path="/IPO/Draft-Prospectus" element={<DraftProsp />} />
                            <Route path="/IPO/Best-Performers" element={<BestPerformers />} />
                            <Route path="/IPO/IPO-Synopsis/:getCompName/:getcocode" element={<IPOSynopsis />} />
                            <Route path="/IPO/IPO-News" element={<IPONews />} />
                            <Route path="/Futures-And-Options/Nifty-Futures" element={<NiftyFutures />} />
                            <Route path="/Futures-And-Options/Top-Value-Traded" element={<TopValueTraded />} />
                            <Route path="/Futures-And-Options/Derivative-Summary" element={<DerivativeSummary />} />
                            <Route path="/Futures-And-Options/FII-Statistics" element={<FIIStatistics />} />
                            <Route path="/Futures-And-Options/List-of-underlying-Securities" element={<ListOfUnderlyings />} />
                            <Route path="/Futures-And-Options/Top-Quantity" element={<TopQuantity />} />
                            <Route path="/Futures-And-Options/Put-Call-Ratio" element={<PutCallRatio />} />
                            <Route path="/Futures-And-Options/Cost-of-Carry" element={<CostOfCarry />} />
                            <Route path="/Futures-And-Options/Position-Limit" element={<PositionLimit />} />
                            <Route path="/Futures-And-Options/Roll-Over" element={<RollOver />} />
                            <Route path="/Futures-And-Options/Derivative-News" element={<DerivativeNews />} />
                            <Route path="/Futures-And-Options/Most-Active-Contracts" element={<MostActiveContracts />} />
                            <Route path="/Futures-And-Options/All-Index-Future" element={<AllIndexFuture />} />
                            <Route path="/Futures-And-Options/Top-Gainers-Futures" element={<Topgain />} />
                            <Route path="/Futures-And-Options/Top-Losers-Futures" element={<TLosers />} />
                            <Route path="/Futures-And-Options/Highest-in-OI-Futures" element={<HighestInOI />} />
                            <Route path="/Futures-And-Options/Lowest-in-OI-Futures" element={<LowestInOI />} />
                            <Route path="/Futures-And-Options/Increase-in-OI-Futures" element={<IncreaseInOI />} />
                            <Route path="/Futures-And-Options/Decrease-in-OI-Futures" element={<DecreaseInOI />} />
                            <Route path="/Futures-And-Options/Most-Active-Call" element={<MostActiveCallOPT />} />
                            <Route path="/Futures-And-Options/Most-Active-Put" element={<MostActivePutOPT />} />
                            <Route path="/Futures-And-Options/Top-Gainers-Options" element={<TopGainers />} />
                            <Route path="/Futures-And-Options/Top-Losers-Options" element={<TopLosers />} />
                            <Route path="/Futures-And-Options/Highest-in-OI-Options" element={<HighOI />} />
                            <Route path="/Futures-And-Options/Lowest-in-OI-Options" element={<LowOI />} />
                            <Route path="/Futures-And-Options/Option-Chain" element={<OptionChains />} />
                            <Route path="/Futures-And-Options/Increase-in-OI-Options" element={<IncreaseOI />} />
                            <Route path="/Futures-And-Options/Decrease-in-OI-Options" element={<DecreaseOI />} />
                            <Route path="/MutualFund/Historical-NAV" element={<HistoricalNav />} />
                            <Route path="/MutualFund/Mutual-Fund-Activities" element={<MFActivities />} />
                            <Route path="/MutualFund/Top-10-Holding" element={<TopHolding />} />
                            <Route path="/Mutual-Fund-SIP-Calculator" element={<SIPCalculator />} />
                            <Route path="/MutualFund/Fund-Profile" element={<FundProfile />} />
                            <Route path="/MutualFund/Mutual-Fund-News" element={<Mutualnews />} />
                            <Route path="/MutualFund/Category-Return" element={<Categoryreturn />} />
                            <Route path="/ReferEarn" element={<ReferEarn />} />
                            <Route path="/userReferal" element={<ReferEarnNew />} />
                             <Route path="/userReferalSigUp" element={<ReferSignUp />} />
                            <Route path="/Trade-Radar-Algo-G" element={<TradeRadarAlgoFb />} />
                            <Route path="/TradeRadar-Algo-Fb" element={<TradeRadarAlgoFbBlack />} />
                            <Route path="/ReferralProgramPolicy" element = {<ReferralProgramPolicy />} />

                            {/* <Route path="/ticker" element={<Ticker />} /> */}
                            <Route path="/OurTools" element={<OurTools />} />
                            <Route path="/AlgoBulls" element={<AlgoBulls />} />
                            <Route path="/AlgoTrading" element={<AlgoTrading />} />
                            {/* <Route path="/BrokerageAndCalculators" element={<BrokerageAndCalculators />} /> */}
                            <Route path="/Contact" element={<Contact />} />
                            <Route path="/DialNTrade" element={<DialNTrade />} />
                            <Route path="/PartnerUs" element={<PartnerUsNew />} />
                            <Route path="/Downloads" element={<Downloads />} />
                            <Route path="/Sitemap" element={<Sitemap />} />
                            <Route path="/Careers" element={<CareerLanding />} />
                            <Route path="/Careers/:job_id" element={<Career />} />
                            <Route path="/CareersInner/:job_id" element={<CareerInner />} />
                            <Route path="/Research" element={<Research />} />
                            {/* <Route path="/EMICalculator" element={<EMICalculator />} /> */}

                            <Route path="/RiskDisclosures" element={<RiskDisclosures />} />
                            <Route path="/Quantman" element={<Quantman />} />

                            {!report.includes(window.location.pathname) ?
                                <Route path="/Research/:feed" element={<Morningnote />} /> :
                                <Route path="/Research/:catname" exact element={<ResearchReport />} />
                            }
                            {/* {!report.includes(window.location.pathname) ?
            <Route path="/Research/:feed" element={<Markethunt />} />:
            <Route path="/Research/:catname" exact element={<ResearchReport />} /> 
        }  */}
                            <Route path="/Research/:feed/:catname" element={<Morningnote />} />
                            <Route path="/Research/:feed/:catname" element={<Markethunt />} />
                            <Route path={internalResearch} exact element={<Externalresearch />} />
                            <Route path={internalhome} exact element={<Externalhome />} />
                            {/* <Route path="/Algotradinglanding" element={<Algotradinglanding />} /> */}
                            {/* <Route path="/AlgoTrading-ad1" element={<AlgoTradingad1 />} exact /> */}
                            <Route path="/AlgoTrading-ad2" element={<AlgoTradingad2 />} exact />
                            {/* <Route path="/FutureOption-ad1" element={<FutureOptionad1 />} exact /> */}
                            <Route path="/DematAccount-ad1" element={<DematAccountad1 />} exact />
                            <Route path="/ThanksYou" element={<ThankYouPage />} />
                            <Route path="/AccountClosure" element={<AccountClosure />} />
                            <Route path="/AccountClosureOption" element={<AccountClosureOption />} />
                            <Route path="/AccountClosureForm" element={<AccountClosureForm />} />
                            <Route path="/stocks/:requestcompname" element={<CompanySnapshot />} />
                            <Route path="/CompanySnapshot/:requestcompname" element={<CompanySnapshotIframe />} />
                            <Route path="/Fd-calculator" element={<Fdcalculator />} exact />
                            <Route path="/Emi-calculator" element={<Emicalculator />} exact />
                            <Route path="/Elss-calculator" element={<Elsscalculator />} exact />
                            <Route path="/Brokerage-calculator" element={<Brokaragecalculator />} exact />
                            <Route path="/Nominee-Updation" element={<NomineeUpdation />} exact />
                            <Route path="/Investor-Relations" element={<InvesterRelation />} /> 

                            <Route path="/keev" element={<KeevInner />}  /> 
                            {/* <Route path="/Trade-Radar" element={<KeevInner />}  />  */}
                            <Route path="/margin-pledge" element={<MarginInner />} /> 
                            <Route path="/Product" element={<ProdcutPage />} /> 
                            {/* <Route path="/trade-radar" element={<Traderader />} />  */}
                            <Route path="/trading-view" element={<TradingView />} /> 

                      <Route path="/api" element={<MarketFeedRedirect />} />
                                
                            {/* <Route path="/Static/backoffice.aspx" element={<External />} />   
        <Route path="/static/my-account.aspx" element={<Externalmyaccount />} />  
        <Route path="/Static/my-account.aspx" element={<Externalmyaccount />} />  
        <Route path="/static/online-share-trading.aspx" element={<Externalhome />} /> 
        <Route path="/Static/online-share-trading.aspx" element={<Externalhome />} /> 
                      <Route path="/static/contact-us.aspx" element={<ExternalContact />} />   
                      <Route path="/Static/contact-us.aspx" element={<ExternalContact />} /> 
                      <Route path="/static/careers.aspx" element={<ExternalCareerLanding />} /> 
                      <Route path="/static/Careers.aspx" element={<ExternalCareerLanding />} /> 
        <Route path="/static/Terms-and-condition.aspx" element={<ExternalTermsandcondition />} /> 
        <Route path="/Static/Terms-and-condition.aspx" element={<ExternalTermsandcondition />} /> 
        <Route path="/static/online-equity-trading.aspx" element={<Externalhome />} /> 
        <Route path="/Static/online-equity-trading.aspx" element={<Externalhome />} /> 
        <Route path="/static/trading-call-registration.aspx" element={<Externalhome />} />
        <Route path="/Static/trading-call-registration.aspx" element={<Externalhome />} />  */}
                        </Routes>

                        <LoginPopup />
                        {/* <AllEquities /> */}

                        {/* {!pathArr.includes(window.location.pathname) && <Footer />}
                        {!pathArr.includes(window.location.pathname) && <StickyFooter />} */}

                        {/* {(window.location.pathname.split('/')[1] != 'CompanySnapshot') ? !pathArr.includes(window.location.pathname) && <Footer /> :
                            !pathArrStock.includes(window.location.pathname.split('/')[1]) && <Footer />}

                        {(window.location.pathname.split('/')[1] != 'CompanySnapshot') ? !pathArr.includes(window.location.pathname) && <StickyFooter /> :
                            !pathArrStock.includes(window.location.pathname.split('/')[1]) && <StickyFooter />} */}


                      {/* Render Footer only if NOT in noHeaderFooterPaths */}
            {(window.location.pathname.split('/')[1] !== 'CompanySnapshot') ? (!pathArr.includes(currentPath) &&!noHeaderFooterPaths.includes(currentPath) && <Footer />
            ) : (!pathArrStock.includes(window.location.pathname.split('/')[1]) &&!noHeaderFooterPaths.includes(currentPath) && <Footer />
            )}

            {/* Render StickyFooter only if NOT in noHeaderFooterPaths */}
            {(window.location.pathname.split('/')[1] !== 'CompanySnapshot') ? (!pathArr.includes(currentPath) &&!noHeaderFooterPaths.includes(currentPath) && <StickyFooter />
            ) : (!pathArrStock.includes(window.location.pathname.split('/')[1]) &&!noHeaderFooterPaths.includes(currentPath) && <StickyFooter />
            )}
                    </HelmetProvider>
                </CommonProvider>
            </div>
        </>
    );
}

export default App;
